import React, { ComponentProps } from 'react';
import { asFetchableBlock } from '../../_lib/BlockFetcher';
import { BlockType } from '../../types/api/ElementType';
import { useAppContext } from '../../contexts/AppContext/AppContext';
import { ExternalContentDefaultView } from '../../_lib/components/ExternalContent/views/ExternalContentDefaultView';
import { PdfFileDetailsBlockProps, PdfFileDetailsInteractions } from './partials/PdfFileDetailsInteractions';

function PdfFileDetails({ views, activeView = 'default' }: PdfFileDetailsBlockProps) {
  const { editModeInfo } = useAppContext();
  const { active } = editModeInfo;
  switch (active) {
    case true:
      // EditMode
      return <PdfFileDetailsInteractions views={views} activeView={activeView} />;
    default:
      // LiveMode:
      return <ExternalContentDefaultView {...views.default} />;
  }
}

export const PdfFileDetailsBlock = asFetchableBlock(PdfFileDetails, BlockType.pdffiledetails);
export type PdfFileDetailsBlock = ComponentProps<typeof PdfFileDetailsBlock>;
